import _ from "lodash";
import { LabelTextObject } from "@adactive/adsum-web-map";
import { labelStyle, iconLabelStyle } from "../../utils/constants";

const scaledImageLabel = [];
let showedTextLabel = [];

export const addLabelAboveIcon = (ACA, awm, placeId) => {
  const tempPoi = ACA.getPoisFromPlace(placeId);
  const tempLocation = awm.wayfindingManager.locationRepository.get(placeId);
  if (tempPoi && tempPoi[0] && tempPoi[0].name && tempLocation) {
    const tempIconLabel = new LabelTextObject({
      text: ` ${tempPoi[0].name} `,
      offset: iconLabelStyle.offset,
      style: iconLabelStyle.style
    });
    awm.objectManager.addLabelOnAdsumLocation(tempIconLabel, tempLocation);
    showedTextLabel.push(
      Array.from(awm.objectManager.labels)[
        Array.from(awm.objectManager.labels).length - 1
      ]
    );
  }
};

export const makeItBounceUpandBlink = (
  ACA,
  awm,
  currentSelectedObject,
  wayFindingControlsState
) => {
  if (
    currentSelectedObject.length &&
    wayFindingControlsState.placeDestination === null
  ) {
    _.forEach(currentSelectedObject, spaceObject => {
      if (spaceObject.isLabel) {
        addLabelAboveIcon(ACA, awm, spaceObject.placeId);
        spaceObject.setScale(2, 2, 2);
        scaledImageLabel.push(spaceObject);
      } else {
        spaceObject.bounceUp(5);
        if (
          Array.from(spaceObject.labels) &&
          Array.from(spaceObject.labels)[0] &&
          Array.from(spaceObject.labels)[0].isLabelImage
        ) {
          const getLabel = Array.from(spaceObject.labels)[0];
          getLabel.setScale(2, 2, 2);
          addLabelAboveIcon(ACA, awm, spaceObject.placeId);

          scaledImageLabel.push(getLabel);
        } else if (spaceObject.placeId) {
          const poiName = ACA.getPoisFromPlace(spaceObject.placeId);
          if (poiName && poiName[0]) {
            const tempSpaceLabel = new LabelTextObject({
              text: ` ${poiName[0].name} `,
              offset: labelStyle.arrival.offset,
              style: labelStyle.arrival.style
            });
            awm.objectManager.addLabel(tempSpaceLabel, spaceObject);
            showedTextLabel.push(
              Array.from(awm.objectManager.labels)[
                Array.from(awm.objectManager.labels).length - 1
              ]
            );
          }
        }
      }
    });
  } else if (showedTextLabel.length && showedTextLabel.length > 1) {
    try {
        showedTextLabel.forEach((label) => {
            awm.objectManager.removeLabel(label[1]);
        });
        showedTextLabel = [];
    } catch (err) {
        console.log(err);
    }
}
};



// WEBPACK FOOTER //
// ./src/components/map/index.js